import { action } from 'typesafe-actions';

import { IAnalyticsData } from 'APIPackage/AnalyticsModule/interfaces/IAnalyticsData';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

import { IAnalyticsFilter } from '../interfaces/IAnalyticsFilter';
import { AnalyticsActionsEnum } from '../enums/AnalyticsActionsEnum';

export const analyticsGetData = () => action(AnalyticsActionsEnum.ANALYTICS_GET_DATA);
export const analyticsSetData = (data: IAnalyticsData[]) => action(AnalyticsActionsEnum.ANALYTICS_SET_DATA, { data });
export const analyticsSetFilter = (filter: IAnalyticsFilter) =>
  action(AnalyticsActionsEnum.ANALYTICS_SET_FILTER, { filter });
export const analyticsExport = (format: ExportFormatsEnum) => action(AnalyticsActionsEnum.ANALYTICS_EXPORT, { format });
export const analyticsKnmGetData = () => action(AnalyticsActionsEnum.ANALYTICS_KNM_GET_DATA);
export const analyticsKnmGetDataNextPage = () => action(AnalyticsActionsEnum.ANALYTICS_KNM_GET_DATA_NEXT_PAGE);
export const analyticsKnmSetData = (data: IKnmRaw[], page: number, pageCount: number, totalCount: number) =>
  action(AnalyticsActionsEnum.ANALYTICS_KNM_SET_DATA, { data, page, pageCount, totalCount });
export const analyticsKnmSetFilter = (filter: IAnalyticsFilter) =>
  action(AnalyticsActionsEnum.ANALYTICS_KNM_SET_FILTER, { filter });
export const analyticsKnmSetOrder = (order: string | null) =>
  action(AnalyticsActionsEnum.ANALYTICS_KNM_SET_ORDER, { order });
export const analyticsKnmExport = (format: ExportFormatsEnum) =>
  action(AnalyticsActionsEnum.ANALYTICS_KNM_EXPORT, { format });
export const analyticsInit = () => action(AnalyticsActionsEnum.ANALYTICS_INIT);
